import api from "../api";
import type {
  AuditChangeGroup,
  AuditChangeLogItem,
  AuditGroupedChangesParams,
  AuditPagedResponse,
  AuditTransactionDetails,
  AuditTransactionListItem,
  AuditTransactionsSearchParams,
} from "../../types/audit";

const toPagedResponse = <T>(payload: any, size: number): AuditPagedResponse<T> => ({
  content: Array.isArray(payload?.content) ? payload.content : [],
  page: payload?.page ?? 0,
  size: payload?.size ?? size,
  totalElements: payload?.totalElements ?? 0,
  totalPages: payload?.totalPages ?? 0,
  first: payload?.first ?? true,
  last: payload?.last ?? true,
});

export const searchAuditTransactions = async (
  params: AuditTransactionsSearchParams
): Promise<AuditPagedResponse<AuditTransactionListItem>> => {
  try {
    const response = await api.post("/audit/transactions/search", params);
    return toPagedResponse<AuditTransactionListItem>(response.data?.data ?? response.data, params.size);
  } catch (error) {
    console.error("Error fetching audit transactions:", error);
    throw error;
  }
};

export const getAuditTransactionDetails = async (transactionId: string): Promise<AuditTransactionDetails> => {
  try {
    const response = await api.get(`/audit/transactions/${transactionId}`);
    return response.data?.data ?? response.data;
  } catch (error) {
    console.error("Error fetching audit transaction details:", error);
    throw error;
  }
};

export const getAuditTransactionChanges = async (
  transactionId: string,
  page = 0,
  size = 10
): Promise<AuditPagedResponse<AuditChangeLogItem>> => {
  try {
    const params = new URLSearchParams({ page: String(page), size: String(size) });
    const response = await api.get(`/audit/transactions/${transactionId}/changes?${params.toString()}`);
    return toPagedResponse<AuditChangeLogItem>(response.data?.data ?? response.data, size);
  } catch (error) {
    console.error("Error fetching audit transaction changes:", error);
    throw error;
  }
};

export const getAuditTransactionGroupedChanges = async (
  transactionId: string,
  { page = 0, size = 10, ...filters }: AuditGroupedChangesParams = {}
): Promise<AuditPagedResponse<AuditChangeGroup>> => {
  try {
    const params = new URLSearchParams({ page: String(page), size: String(size) });

    Object.entries(filters).forEach(([chave, valor]) => {
      const conteudo = String(valor ?? "").trim();
      if (conteudo) params.append(chave, conteudo);
    });

    const response = await api.get(`/audit/transactions/${transactionId}/grouped-changes?${params.toString()}`);

    return toPagedResponse<AuditChangeGroup>(response.data?.data ?? response.data, size);
  } catch (error) {
    console.error("Error fetching audit transaction grouped changes:", error);
    throw error;
  }
};
